module.exports = __webpack_public_path__ + "spa_static_mobile/img/approve.2a4f63cc.png";